


import { Component, Vue } from 'vue-property-decorator';

import Input, {
  InputType,
  InputStyle,
  InputLabelColor,
} from '@/shared/components/input.component.vue';

@Component({
  components: {
    Input,
  },
})
export default class PartialInput extends Vue {
  private inputTest = '';
  private inputError = 'Mensaje de error';
  private inputType = InputType;
  private inputStyle = InputStyle;
  private inputLabelColor = InputLabelColor;

  private hideError() {
    this.inputError = '';
  }
}
